import * as R from 'ramda'
import { call, reducer } from '../../helpers/api/meta'
import { getCourseAdminDashboard } from '../../helpers/api/api';

export const GET_COURSE_ADMIN_DASHBOARD = 'GET_COURSE_ADMIN_DASHBOARD'

export const callGetCourseAdminDashboard = (inputs) => {
    const meta = {
        endpoint: (params) => getCourseAdminDashboard(params),
        inputs,
        action: GET_COURSE_ADMIN_DASHBOARD,
        messages: {
            id: 'getCourseAdminDashboard',
            failure: 'Could not get course admin dashbaord'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    dashboard: {}
}

const saveCourseAdminDashboard = (state, action) => {
    return R.assoc('dashboard', action, state);
}

const messages = {
    loadFailed: 'Could not load courses.',
}

export default reducer(initialState, GET_COURSE_ADMIN_DASHBOARD, saveCourseAdminDashboard, messages.loadFailed)